import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import LoaderText from '../components/loader/LoaderText';
import Error404 from '../pages/error/Error404';
import { NAVIGATE_ADMIN } from '../constant';
import AdminLayout from '../layout/AdminLayout';

const AdminDashboard = lazy(() => import('../pages/admin/dashboard'));
const HospitalList = lazy(() => import('../pages/admin/hospital'));
const BloodBankList = lazy(() => import('../pages/admin/blood-bank'));
const SchemeList = lazy(() => import('../pages/admin/schemes'));
const SearchAdminHospital = lazy(() => import('../pages/admin/hospital/search-hospital'));

const CallsDashboardPage = lazy(() => import('../pages/admin/calls'));
const UsersList = lazy(() => import('../pages/admin/users'));
const BeneficiaryList = lazy(() => import('../pages/admin/calls/beneficiary'));
const BeneficiaryDetailsPage = lazy(() => import('../pages/admin/calls/beneficiary/detail'));
const WhatsAppVisitorsList = lazy(() => import('../pages/admin/users/visitors-list'));
const ProfilePage = lazy(() => import('../pages/admin/profile'));
const ProfileUpdatePage = lazy(() => import('../pages/admin/profile/UpdateProfile'));

const AdminRoute = () => {
    return (
        <Suspense fallback={<AdminLayout><LoaderText /></AdminLayout>}>
            <AdminLayout>
                <Routes>
                    <Route path='*' element={<Error404 />} />
                    <Route path={NAVIGATE_ADMIN.DASHBOARD} element={<AdminDashboard />} />
                    <Route path={NAVIGATE_ADMIN.HOSPITAL_LIST} element={<HospitalList />} />
                    <Route path={NAVIGATE_ADMIN.BLOOD_BANK} element={<BloodBankList />} />
                    <Route path={NAVIGATE_ADMIN.SCHEME_LIST} element={<SchemeList />} />
                    <Route path={NAVIGATE_ADMIN.SCHEME_HOSPITAL_LIST} element={<HospitalList />} />
                    <Route path={NAVIGATE_ADMIN.SEARCH_HOSPITALS} element={<SearchAdminHospital />} />
                    <Route path={NAVIGATE_ADMIN.CALLS_DASHBOARD} element={<CallsDashboardPage />} />
                    <Route path={NAVIGATE_ADMIN.USER_LIST} element={<UsersList />} />
                    <Route path={NAVIGATE_ADMIN.BENEFICIARY_LIST} element={<BeneficiaryList />} />
                    <Route path={NAVIGATE_ADMIN.BENEFICIARY_DETAILS} element={<BeneficiaryDetailsPage />} />
                    <Route path={NAVIGATE_ADMIN.WHATSAPP_VISITORS} element={<WhatsAppVisitorsList />} />
                    <Route path={NAVIGATE_ADMIN.PROFILE} element={<ProfilePage />} />
                    <Route path={NAVIGATE_ADMIN.PROFILE_UPDATE} element={<ProfileUpdatePage />} />
                </Routes>
            </AdminLayout>
        </Suspense>
    );
};

export default AdminRoute;
